// extracted by mini-css-extract-plugin
module.exports = {"ExternalSourceLink":"ExternalSourceLink_ExternalSourceLink__3dXPF"};